import axios from 'axios';

const URL = process.env.REACT_APP_API_URL_WEBHOOK

function tzOffset(): string {
    const off = new Date().getTimezoneOffset();
    const sign = off <= 0 ? '+' : '-';
    const h = String(Math.floor(Math.abs(off) / 60)).padStart(2, '0');
    const m = String(Math.abs(off) % 60).padStart(2, '0');
    return `${sign}${h}:${m}`;
}

function toDatetimeRange(date_from?: string, date_to?: string): Record<string, string> {
    const tz = tzOffset();
    return {
        ...(date_from && { date_from: `${date_from}T00:00:00${tz}` }),
        ...(date_to   && { date_to:   `${date_to}T23:59:59${tz}` }),
    };
}

export const getTemplateDashboard = (params: { program_id?: number; date_from?: string; date_to?: string } = {}) => {
    const { date_from, date_to, ...rest } = params;
    const query = new URLSearchParams({ ...rest as any, ...toDatetimeRange(date_from, date_to) }).toString();
    return axios.get(`${URL}/template-sends/dashboard/${query ? '?' + query : ''}`)
}

export const getTemplateDashboardByProgram = (params: { date_from?: string; date_to?: string } = {}) => {
    const query = new URLSearchParams(toDatetimeRange(params.date_from, params.date_to)).toString();
    return axios.get(`${URL}/template-sends/dashboard/by-program/${query ? '?' + query : ''}`)
}

export const getTemplateBlocks = (params: { template_name?: string; program_id?: number } = {}) => {
    const query = new URLSearchParams(params as any).toString()
    return axios.get(`${URL}/template-sends/blocks/${query ? '?' + query : ''}`)
}
